import { Box, Chip, TextField } from "@material-ui/core";
import { red } from "@material-ui/core/colors";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
    Collections,
    Incident,
    Infraction,
    PenaltyDescriptionByType,
} from "api";
import { useFormikContext } from "formik";
import get from "lodash/get";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/model";

interface InfractionSelectionProps {
    options: Infraction[];
}

const InfractionSelection: React.FC<InfractionSelectionProps> = ({
    options,
}) => {
    const {
        setFieldValue,
        handleBlur,
        errors,
        values,
    } = useFormikContext<Incident>();

    const infractionsObject =
        useSelector(
            (state: RootState) => state.firestore.data[Collections.INFRACTIONS]
        ) || {};

    return (
        <Autocomplete
            style={{
                width: "100%",
            }}
            clearText="Limpar"
            clearOnEscape
            clearOnBlur
            options={options}
            getOptionSelected={(option, infraction) =>
                option.id === infraction.id
            }
            onBlur={handleBlur}
            onChange={(event, infraction) => {
                if (infraction) {
                    setFieldValue("infractionId", infraction.id);
                }
            }}
            getOptionLabel={(infraction) =>
                `${infraction.key} - ${infraction.description} (${
                    PenaltyDescriptionByType[infraction.penaltyType || ""]
                })`
            }
            renderInput={(params) => {
                const error = get(errors, "infractionId");

                let helperText = "";

                if (
                    values.infractionId &&
                    infractionsObject[values.infractionId]
                ) {
                    const infraction: Infraction =
                        infractionsObject[values.infractionId];
                    helperText = `${infraction.key} - ${
                        infraction.description
                    } (${
                        PenaltyDescriptionByType[infraction.penaltyType || ""]
                    })`;
                }

                return (
                    <Box display="flex" flexDirection="column">
                        <TextField
                            {...params}
                            label="Infração"
                            error={!!error}
                            helperText={!!error ? error : ""}
                        />
                        {helperText && (
                            <Chip
                                label={helperText}
                                color="secondary"
                                style={{
                                    fontSize: 14,
                                    fontWeight: 500,
                                    backgroundColor: red["700"],
                                    color: "white",
                                }}
                                onDelete={() =>
                                    setFieldValue("infractionId", "")
                                }
                            />
                        )}
                    </Box>
                );
            }}
        />
    );
};

export { InfractionSelection };
